export const CLICK_MENU_ITEM = '[MENU] CLICK_MENU_ITEM';
export const CLICK_LOGOUT_ITEM = '[MENU] CLICK_LOGOUT_ITEM';
export const CLICK_EXPORT_ITEM = '[MENU] CLICK_EXPORT_ITEM';
export const TOGGLE = '[MENU] TOGGLE';
export const TRIGGER_REFRESH_MENU_ITEMS = '[MENU] TRIGGER_REFRESH_MENU_ITEMS';

export default {
    CLICK_LOGOUT_ITEM,
    CLICK_EXPORT_ITEM,
    CLICK_MENU_ITEM,
    TOGGLE,
    TRIGGER_REFRESH_MENU_ITEMS
}


// WEBPACK FOOTER //
// ./src/view/constant/MenuConstant.js